import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import ProgramAndPhaseForm from '@/forms/ProgramAndPhaseForm';
import type { EpisodeOfCare } from '@/types/episodeOfCare';
import { Alert, Modal, Typography } from '@/ui';

interface Props {
  onClose: () => void;
  open: boolean;
  episodeOfCare: EpisodeOfCare;
}

export const ProgramCorrectionModal = ({ onClose, open, episodeOfCare }: Props) => {
  return (
    <Modal open={open} onClose={() => onClose()} overflowVisible={true} size="lg">
      <Alert variant="error" dismissable={false}>
        <div className="mb-2">
          <Typography variant="heading" className="text-red-700">
            Program correction — use with caution
          </Typography>
        </div>
        <p className="text-sm text-red-800">
          This rewrites the member&apos;s <strong>current</strong> program record to fix a
          data-entry error. It does <strong>not</strong> create a new phase, preserves no treatment
          history, and will <strong>not</strong> end custom schedule expectations. If the member is
          actually transitioning, close this and use the <FontAwesomeIcon icon={faPencil} /> action
          instead.
        </p>
      </Alert>

      <ProgramAndPhaseForm
        episodeOfCare={episodeOfCare}
        onCancel={() => onClose()}
        onSuccess={() => onClose()}
        personId={episodeOfCare.member_id}
      />
    </Modal>
  );
};
